import Options from './Options';

export default Options;


// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/questions/options/index.js